import {
    SET_USER,
    LOGOUT,
    LOGIN_FAILURE,
    CLEAR_ERROR,
    UPDATE_USER_DIAGNOSES,
    BIND_WECHAT,
    UNBIND_WECHAT,
    WECHAT_BINDING_ERROR,
} from '../actionTypes';
import Cookies from 'js-cookie';

/**
 * 设置用户信息的 action creator
 * @param {Object} userData - 用户数据
 * @returns {Object} action 对象
 */
export const setUser = (userData) => ({
    type: SET_USER,
    payload: userData,
});

/**
 * 登出的 action creator
 * @returns {Object} action 对象
 */
export const logout = () => {
    // 清除 Cookie
    Cookies.remove('userInfo');

    return {
        type: LOGOUT,
    };
};

/**
 * 登录失败的 action creator
 * @param {string} error - 错误信息
 * @returns {Object} action 对象
 */
export const loginFailure = (error) => ({
    type: LOGIN_FAILURE,
    payload: error,
});

/**
 * 清除错误信息的 action creator
 * @returns {Object} action 对象
 */
export const clearError = () => ({
    type: CLEAR_ERROR,
});

/**
 * 更新用户舌诊次数
 * @param {number} amount - 要减少的剩余次数
 */
export const updateUserDiagnoses = (amount) => {
    // 从 Cookie 中获取当前用户信息
    const userInfo = Cookies.get('userInfo');
    if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);

        // 更新 Cookie 中的剩余次数
        const updatedUserInfo = {
            ...parsedUserInfo,
            surplus: parsedUserInfo.surplus - amount,
        };
        // 将更新后的用户信息保存回 Cookie
        Cookies.set('userInfo', JSON.stringify(updatedUserInfo));
    }

    return {
        type: UPDATE_USER_DIAGNOSES,
        payload: amount,
    };
};

/**
 * 绑定微信的 action creator
 * @param {Object} wechatInfo - 微信信息
 */
export const bindWechat = (wechatInfo) => {
    console.log('acitonWeChatInfo', wechatInfo);
    const userInfo = Cookies.get('userInfo');
    if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        const updatedUserInfo = {
            ...parsedUserInfo,
            wechatInfo,
        };
        Cookies.set('userInfo', JSON.stringify(updatedUserInfo));
    }
    return {
        type: BIND_WECHAT,
        payload: wechatInfo,
    };
};

/**
 * 解绑微信的 action creator
 */
export const unbindWechat = () => {
    const userInfo = Cookies.get('userInfo');
    if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        const updatedUserInfo = {
            ...parsedUserInfo,
            wechatInfo: null,
        };
        Cookies.set('userInfo', JSON.stringify(updatedUserInfo));
    }
    return {
        type: UNBIND_WECHAT,
    };
};

/**
 * 微信绑定错误的 action creator
 * @param {string} error - 错误信息
 */
export const wechatBindingError = (error) => ({
    type: WECHAT_BINDING_ERROR,
    payload: error,
});
